import React from "react";
import { Tooltip, useTheme } from "@mui/material";
import { colors } from "../utils/colors";

const TooltipBox = ({ title, children, arrow = true, ...props }) => {
  const theme = useTheme();
  return (
    <Tooltip
      title={title}
      arrow
      {...props}
      disableInteractive
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: "12px",
            fontFamily: "Roboto",
            fontWeight: "400",
            bgcolor: theme.palette.primary.light,
            "& .MuiTooltip-arrow": {
              color: theme.palette.primary.light,
              width: "0.5em !important",
              height: "0.8em !important",
              marginLeft: "-0.5em !important",
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipBox;
